
import orderNowUpIcon from "../../../../../assets/images/orderNowUpIcon.svg";
import { useTranslation } from "react-i18next";
import { getExploreBrotherDevicesLink } from "../../../../../constants/AppMethod";
import "./PromotionCards.css";

const PromotionCards = (props) => {
    const { t } = useTranslation(["translation"]);
    const { imageSrc, heading, title, description } = props;
    let exploreBrotherDevicesLink = getExploreBrotherDevicesLink();

    return (
        <div className="promo-container">
            <div className="promo-card-image">
                <img src={imageSrc} alt="promoimage" max-width="100%" height="auto" loading='lazy'/>
            </div>
            <div className="promo-info-container">
                <div className="promo-heading">
                    {heading}
                </div>
                <div className="promo-title">
                    {title}
                </div>
                <div className="promo-description">
                    {description}
                </div>
                <a href={exploreBrotherDevicesLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}
                >
                    <div className="promo-buttons">
                        {t("CONNECT_DASHBOARD.PROMOTION_CARDS.ORDER_NOW")}
                        <img src={orderNowUpIcon} alt="orderNowUpIcon" />
                    </div>
                </a>
            </div>
        </div>
    )
}

export default PromotionCards;